// BUILD-042 — Consolidated candidate release reconciliation (2026-10-07).
// Authority: docs/superpowers/decisions/2026-10-07-build-042-consolidated-candidate-release-reconciliation.md
// R3: "Local simulation not clearly separated from ordinary signed-in experience... make
// simulation/nonpersistence explicit and distinguish it from real UAT... Kiro owns the smallest
// correction; no request backend, broader role system or redesign is requested."
//
// This is a single shared VISIBLE (never hover-only) disclosure line, reusing the EXACT wording
// pattern already established and accepted elsewhere in this codebase
// (preview/sections/AdditionalInfoSection.tsx: "Local demonstration only. Reloading this page
// resets all entries.") — not new policy language, just applying that same already-authorized
// disclosure convention to the components R3 found missing it: RequestCorrectionCard,
// CorrectionRequestsPanel, HistorySelfSection, MyHrQualifications' self-reported/license
// sections, and MyHrSections' Immigration/Salary/Personal-Details-admin-edit blocks. Renders
// unconditionally (not behind a hover title, not inside a collapsed help section) so a real
// signed-in DEV user cannot miss it while using the control.
export function LocalDemoNote({ text = 'Local demonstration only. Nothing here is saved — reloading this page resets it.' }: { text?: string }) {
  return <p className="text-[11px] text-gray-400 mt-2">{text}</p>;
}
